import { computed } from 'vue';
import { useLanguage } from '@/hooks';
import { isEmpty } from 'lodash-es';

const { t } = useLanguage();
const defaultCountryCodeOptions = computed(() => [{ label: t('Country.BRAZIL', 'enums') + ' +55', value: '+55' }]);
const defaultCountryCodeOptions2 = computed(() => [{ label:' +55', value: '+55' , path: "/images/invite_reg/icon_country_BRAZIL.png"}]);


export function generateMobiles(sourceMobileOptions) {
  if (isEmpty(sourceMobileOptions)) {
    return defaultCountryCodeOptions.value;
  } else {
    return sourceMobileOptions.map(smo => {
      return { label: t('Country.' + smo.country, 'enums') + ' ' + smo.code, value: smo.code };
    });
  }
}

export function generateMobiles2(sourceMobileOptions) {
    if (isEmpty(sourceMobileOptions)) {
        return defaultCountryCodeOptions2.value;
    } else {
        return sourceMobileOptions.map(smo => {
            return { label: ' ' + smo.code, value: smo.code, path:  "/images/invite_reg/icon_country_" + smo.country + ".png"};
        });
    }
}
